import * as _ from 'lodash';
import { WindowWrapper } from './globalWrappers';

export function isEnabled(flagName: FeatureFlagName) {
  return _.get(_.find(WindowWrapper.FEATURE_FLAGS, { _id: flagName }), 'enabled', false);
}
